module.exports = __webpack_public_path__ + "img/ln.46bc366c.svg";